module.exports = __webpack_public_path__ + "img/nandu9.ef4323b2.png";